import LIFFUserContext from './contexts/LIFFUserContext';
import { ReactNode, useEffect, useState } from 'react';
import { Profile } from '@liff/get-profile';
import { getLIFFProfile } from './utils';
import axios from 'axios';
import { constants } from './constants';
import { CustomerProfile } from './models/customerProfile';
import useLoading from './contexts/LoadingContext';

const verify = async (profile: Profile) => {
  try {
    return await axios
      .post<{ token: string; isABO: boolean }>(`${constants.endpoint}/auth`, {
        userId: profile.userId,
      })
      .then((res) => {
        return res.data;
      });
  } catch (e) {
    console.log(e);
  }
};

const psInternalUser = async (profile: Profile) => {
  const url = new URL(window.location.href);
  const key = url.searchParams.get('pss');
  const isRegistered = localStorage.getItem('ps-registered');
  try {
    if (!isRegistered) {
      return await axios
        .post(`${constants.endpoint}/ps/${profile.userId}?pss=${key}`)
        .then(() => {
          localStorage.setItem('ps-registered', 'true');
          return verify(profile);
        });
    }
  } catch (e) {
    console.error(e);
  }
  return await verify(profile);
};

export default function LIFFUserProvider({
  children,
}: {
  children: ReactNode;
}) {
  const { setIsLoading } = useLoading();
  const [profile, setProfile] = useState<Profile | void>();
  const [customProfile, setCustomerProfile] = useState<CustomerProfile>();
  const [token, setToken] = useState<string>();

  useEffect(() => {
    getLIFFProfile().then((p) => setProfile(p));
  }, []);

  useEffect(() => {
    if (!profile) {
      return;
    }

    setIsLoading(true);
    let promise = verify;
    if (window.location.search.includes('pss=')) {
      promise = psInternalUser;
    }

    promise(profile)
      .then((result) => {
        if (!result) {
          return;
        }

        const { token, isABO } = result;
        localStorage.setItem('token', token);
        setToken(() => token);
        setCustomerProfile(() => ({
          ...profile,
          isABO,
        }));
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [profile, setIsLoading]);

  return (
    <LIFFUserContext.Provider value={customProfile}>
      {token ? children : <></>}
    </LIFFUserContext.Provider>
  );
}
